import ChildNewButton from './ChildNewButton.vue';
import IChildNewButton from './types';

export { IChildNewButton };
export default ChildNewButton;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/newchildbtn/index.ts